import * as _ from 'lodash';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import type { VoidFunctionComponent } from 'react';

import { v4 } from '../../../../../shared/uuid';
import { useCopyToClipboard } from '../../../../hooks/useCopyToClipboard';
import Button from '../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button/button-constants';
import CardBanner, { CardBannerVariant } from '../../../generic/CardBanner/CardBanner';
import Flex from '../../../generic/Flex';
import { icons } from '../../../generic/Icon/icons';
import { IconText } from '../../../generic/Icon/index';

type BackupCodesProps = {
  codes: string[],
};

const BackupCodes: VoidFunctionComponent<BackupCodesProps> = ({ codes }) => {
  const [isCopied, setIsCopied] = useCopyToClipboard();

  return (
    <>
      <div className="margin-top-md margin-bottom-md">
        Backup codes can be used to sign in if you lose access to your authenticator app.
        Each code can only be used once.
      </div>

      {!(_.isEmpty(codes)) &&
        <CardBanner
          title="Save these backup codes now! You won&apos;t be able to see them again."
          variant={CardBannerVariant.INFO}
        >
          <div className="width-full">
            <Flex gap="12px">
              <Flex direction="column" wrap="wrap" align="flex-start" gap="4px">
                {codes.map((code) => (
                  <div key={v4()}>{code}</div>
                ))}
              </Flex>

              <div className="margin-top-auto margin-left-auto">
                <CopyToClipboard text={codes.join(('\n'))}>
                  <Button
                    size={BUTTON_SIZE.SMALL}
                    type={BUTTON_TYPE.DARK}
                    onClick={() => setIsCopied(true)}
                  >
                    <IconText
                      icon={icons.clipboard}
                      text={isCopied ? 'Copied to clipboard' : 'Copy to clipboard'}
                    />
                  </Button>
                </CopyToClipboard>
              </div>

            </Flex>
          </div>
        </CardBanner>}

    </>
  );
};

export default BackupCodes;
